import { configureStore } from '@reduxjs/toolkit'
import initiativeSlice from './Reducer/reducer';
import scorereducer from './Reducer/scorereducer';
export default configureStore({
  reducer: {
    initiative: initiativeSlice,
    scorereducer:scorereducer
  },
})